export const translations = {
    en: {
        // App name
        appName: 'הרשימה',

        // Authentication
        login: 'Login',
        logout: 'Logout',
        email: 'Email',
        password: 'Password',
        signIn: 'Sign In',

        // Navigation
        dashboard: 'Dashboard',
        sessions: 'Sessions',
        stadium: 'Stadium',
        players: 'Players',
        history: 'Session History',
        navActiveGame: 'Ledger Manager',
        navCommunity: 'Community',
        navHistory: 'Session History',
        sessionManagerSubtitle: 'All your sessions at a glance',
        ledgerManagerSubtitle: 'Ledgers sorted by date',
        hospitality: 'Hospitality',

        // Stadium / Tables
        table: 'Table',
        table1: 'Table 1',
        table2: 'Table 2',
        holdem: 'Texas Hold\'em',
        omaha: 'Omaha',
        seat: 'Seat',
        emptySeat: 'Empty Seat',
        dealer: 'Dealer',

        // Players
        playerName: 'Player Name',
        totalSpent: 'Total Spent',
        totalProfitLoss: 'Profit/Loss',
        addPlayer: 'Add Player',
        selectPlayer: 'Select Player',
        createNewPlayer: 'Create New Player',
        searchPlayers: 'Search players...',

        // Ledger
        ledger: 'Ledger',
        pool: 'Pool',
        house: 'House',
        buyIn: 'Buy-in',
        cashOut: 'Cash-out',
        totalIn: 'Total In',
        income: 'Income',
        expenses: 'Expenses',
        deposits: 'Deposits',
        withdrawals: 'Withdrawals',
        addEntry: 'Add Entry',
        amount: 'Amount',
        description: 'Description',
        timestamp: 'Time',
        grandTotal: 'Grand Total',
        netBalance: 'Net Balance',
        playerList: 'Player List',
        collected: 'Collected',

        // Expense types
        food: 'Food',
        dealerFee: 'Dealer Fee',
        tips: 'Tips',
        fees: 'Fees',

        // Roles
        rolePlayer: 'Player',
        roleFloor: 'Floor',
        roleDealer: 'Dealer',
        slot: 'Slot',
        total: 'Total',
        floor: 'Floor',
        promote: 'קדם',
        demote: 'Demote',
        generalPlayers: 'General Players',
        floors: 'Floors',
        dealers: 'Dealers',
        searchMembers: 'Search members...',

        // Session lifecycle
        startSession: 'Start Session',
        endSession: 'End Session',
        endSessionConfirm: 'Are you sure you want to end this session? All data will be saved to Session History.',
        activeSession: 'Active Session',
        sessionHistory: 'Session History',

        // Session Schedule & Lifecycle
        newSession: 'New Session',
        newGame: 'New Session',           // backwards compat alias
        sessionDate: 'Date',
        sessionTime: 'Time',
        gameDate: 'Date',                 // backwards compat
        gameTime: 'Time',                 // backwards compat
        stakes: 'Stakes',
        minBuyIn: 'Min Buy-in',
        makeRecurring: 'Recurring (weekly)',
        listManagement: 'List Management',
        listManagementSubtitle: 'Active and upcoming sessions',
        currentLedger: 'Active Session',
        futureLedgers: 'Upcoming Sessions',
        noOngoingGame: 'No active session',
        noActiveSession: 'No active session',
        noUpcomingSessions: 'No upcoming sessions',
        goToDashboard: 'Go to Dashboard to start a session',
        scheduleNewGame: 'Schedule a new session',
        ongoing: 'Ongoing',
        upcoming: 'Upcoming',
        startNow: 'Start',
        openLedger: 'Open Ledger',
        viewLedger: 'View Ledger',
        ongoingGame: 'Active Session',
        sessionDetails: 'Session Details',
        saveChanges: 'Save Changes',
        upcomingSessions: 'Upcoming Sessions',
        lastSessions: 'Last Sessions',

        // Actions
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        cancel: 'Cancel',
        confirm: 'Confirm',
        close: 'Close',

        // Language
        language: 'Language',
        english: 'English',
        hebrew: 'עברית',

        // Dashboard
        welcome: 'Welcome',
        dashboardSubtitle: 'Your sessions at a glance.',
        startNewGame: 'New Session',
        lastCompletedGame: 'Last Sessions',
        noCompletedGames: 'No completed sessions yet.',
        viewLedgerHistory: 'View Session History',
        goToHistory: 'All Sessions →',
        nextScheduledGame: 'Next Upcoming Session',
        startsAt: 'Starts at',
        undo: 'Undo',
        redo: 'Redo',
        noUpcomingGames: 'No upcoming sessions scheduled.',
        confirmDeletePlayer: 'Are you sure you want to delete this player?',
        fullNamePlaceholder: 'e.g. David Cohen',
        phonePlaceholder: 'e.g. 054-1234567',
        maxLimitPlaceholder: 'Leave empty for no limit',
        savePlayer: 'Save Player',

        // Community & Profiles
        communitySubtitle: 'Manage your player base, roles, and profiles.',
        playerProfiles: 'Player Profiles',
        noPlayersFound: 'No players found matching your search.',
        emptyPlayersHelp: 'Click "Add New Player" to build your database.',
        addNewPlayer: 'Add New Player',
        searchNamePhone: 'Search by name or phone...',
        noPhone: 'No phone',
        lifetimeNet: 'Lifetime Net',
        editPlayer: 'Edit Player',
        fullName: 'Full Name *',
        phoneNumber: 'Phone Number',
        maxBuyinLimit: 'Max Buy-in Limit (₪)',
        gamesPlayed: 'Games',
        ltv: 'LTV',
        phone: 'Phone',
        maxLimit: 'Max Limit',

        // History
        ledgerHistory: 'Ledger History',
        historySubtitle: 'Review past completed and archived sessions.',
        noHistoryFound: 'No completed or archived sessions found.',
        historyEmptyHelp: 'Games will appear here once you end an active session.',
        historyCompleted: 'Completed',
        viewLedgerDetails: 'View Ledger Details',
        netBalanceHistory: 'Net Balance',

        // Hospitality
        hospitalityTitle: 'Registration Management',
        hospitalityManagement: 'Hospitality Management',
        hospitalitySub: 'Restaurants and menus for your sessions',
        addRestaurant: 'Add Restaurant',
        noRestaurants: 'No restaurants registered yet',
        noRestaurantsSub: 'Add a restaurant manually or import from Wolt',
        items: 'Items',
        confirmDeleteRestaurant: 'Delete this restaurant?',
        editRestaurant: 'Edit Restaurant',
        addNewRestaurant: 'Add New Restaurant',
        importFromWolt: 'Import Menu from Wolt',
        optional: 'Optional',
        importing: 'Importing...',
        import: 'Import',
        applyImport: 'Load menu — can be edited before saving',
        restaurantName: 'Restaurant Name',
        restaurantPlaceholder: "Burger Ranch, McDonald's...",
        menuCount: 'Menu ({{count}} items)',
        addManually: '+ Add Manually',
        itemName: 'Item Name',
        descriptionOptional: 'Description (optional)',
        modifiersOptions: 'Add-ons / Options',
        addGroup: '+ Add Group',
        groupNamePlaceholder: "Group Name (e.g., 'Add-ons', 'Size')",
        required: 'Required',
        multiSelect: 'Multi-select',
        option: 'Option',
        addOption: '+ Add Option',
        saveRestaurant: 'Save Restaurant',
        scrapeError: 'Wolt service is currently unavailable',
        activeSessionFeed: 'Real-time Session Feed',
        liveData: 'LIVE DATA',
        totalPot: 'Total Pot',
        totalRake: 'Total Rake',
        activeSeats: 'Active Seats',
        searchNamePhone: 'Search by name or phone...',
        noActiveRegistrations: 'No Active Registrations',
        whale: 'Whale',
        regular: 'Regular',
        new: 'New',
        time: 'Time',
        seatAtTable: 'Seat at Table',
        seated: 'Seated',
        seatPlayer: 'Seat Player',
        seatPlayerInstructions: 'Please enter the initial Buy-in amount.',
        confirmSeating: 'Confirm Seating',
        accessRestricted: 'Access Restricted',
        backToDashboard: 'Back to Dashboard',

        // Master Ledger
        globalExpenses: 'Global Expenses',
        globalCollected: 'Global Collected (Rake)',
        noExpensesLogged: 'No expenses logged',
        noRakeLogged: 'No rake / collected logged',
        endSessionSummary: 'End Session Summary',
        t1Buyins: 'T1 Buy-ins',
        t2Buyins: 'T2 Buy-ins',
        netPoolRemaining: 'Net Pool Remaining',
        totalPlayersTables: '{{count}} total players across {{tables}}',
        archiveWarning: 'Ending the session will archive all ledgers and update player financials.',
        confirmEnd: 'Confirm End',
        ending: 'Ending...',
        selectTableFor: 'Select Table for {{name}}',
        availableSessions: 'Available Sessions',

        // Table Drawer & Empty States
        openTable: 'Open Table',
        closeTable: 'Close Table',
        tableFull: 'The table is full',
        noExpenses: 'No Expenses',
        noCollections: 'No Collections',
        addExpense: 'Add Expense',
        addCollected: 'Add Collected',

        // New Batch/Action Bar
        itemsSelected: '{{count}} items selected',
        playerExists: 'Already exists. Use {{name}}?',
        removePlayer: 'Remove Player',
        confirmRemovePlayer: 'Are you sure you want to remove {{name}} from the table?',
        payoutErrorNoPlayer: 'Please add a player first',
        confirmExpense: 'Confirm Expense',
        confirmExpenseMsg: 'Add expense of ₪{{amount}} ({{desc}})',
        confirmCollection: 'Confirm Collection',
        confirmCollectionMsg: 'Add collection of ₪{{amount}} ({{desc}})',
        deleteExpense: 'Delete Expense',
        confirmDeleteExpense: 'Are you sure you want to delete the expense of ₪{{amount}} ({{desc}})?',
        deleteCollection: 'Delete Collection',
        confirmDeleteCollection: 'Are you sure you want to delete the collection of ₪{{amount}} ({{desc}})?',
        confirmCashout: 'Confirm Cashout',
        confirmCashoutMsg: 'Confirm cashout for {{name}} of ₪{{amount}}? The player will be removed from the table.',
        cashoutAllTitle: 'Cashout All Players',
        cashoutAllMsg: 'Are you sure you want to perform a bulk cashout for all players at the table?',
        deleteBuyin: 'Delete Buy-in',
        confirmDeleteBuyin: 'Are you sure you want to delete the buy-in of {{name}} for ₪{{amount}}?',
        minBuyStatus: 'Min ₪{{amount}}',
        paid: 'Paid',
        cash: 'Cash',
        credit: 'Credit',
        buyins: 'Buy-ins',
        chips: 'Chips',
        cashoutAll: 'Cash out All',
        bought: 'Bought: ₪{{amount}}',
        approveAll: 'Approve All',
        clearSelection: 'Clear Selection',
        deleteItems: 'Delete Items',
        duplicateItems: 'Duplicate Items',
        confirmDelete: 'Delete Session',
        confirmBulkDelete: 'Bulk Delete',
        confirmDeleteMsg: 'Are you sure you want to delete this session? This action is irreversible.',
        confirmBulkDeleteMsg: 'You are about to delete {{count}} sessions. This action is irreversible.',
        guestWelcome: 'Welcome to the Reshima Demo. Guest data is cleared every 24h.',
        noSessionsYet: 'No sessions yet',
        clickNewSession: 'Click "New Session" to get started',
        recent: 'Recent',
        viewFullHistory: 'View Full History →',
        sessionManager: 'Session Manager',
        sessionManagerSubtitle: 'All your sessions at a glance',
        
        // New Session Modal
        step: 'Step',
        configurationTitle: 'Session Configuration',
        stepDateTime: 'Step 1: Date & Time',
        stepCapacity: 'Step 2: Capacity',
        upTo11: 'Up to 11 players',
        oneTable: '1 Table',
        twoTables: '2 Tables',
        upTo22: 'Up to 22 players',
        stepRecurrence: 'Step {num}: Smart Recurrence',
        oneTime: 'One-time',
        everyWeek: 'Every week (Schedule 4 ahead)',
        stepHospitality: 'Step {num}: Hospitality & Review',
        conciergeAutomation: 'Concierge Automation',
        arrivalConfirmation: 'Arrival Confirmation',
        mealSelection: 'Meal Selection',
        waitlistAutomation: 'Waitlist Automation',
        waitlistAutomationDesc: 'Auto-invite from waitlist if seats open',
        seatSettlement: 'Seat Settlement',
        triggerWhatsApp: 'Trigger WhatsApp on seat arrival',
        selectRestaurants: 'Select Restaurants',
        reviewSummary: 'Review Summary',
        timingLabel: 'Timing:',
        capacityLabel: 'Capacity:',
        automationLabel: 'Automation:',
        creating: 'Creating...',
        creatingSession: 'Creating session...',
        createSession: 'Create Session',
        live: 'LIVE',
        pot: 'POT',
        done: 'DONE',
        start: 'START',
        soon: 'SOON',
        variant: 'Variant',
        stakes: 'Stakes',
        customStakesPlaceholder: 'Custom Stakes (e.g. 50/100)',
        minBuyinAmount: 'Min Buy-in (₪)',
        stepCapacityTitle: 'Step 2: Capacity',
        stepRecurrenceTitle: 'Step {{num}}: Smart Recurrence',
        stepHospitalityTitle: 'Step {{num}}: Hospitality & Review',
        seatSettlementDesc: 'Trigger WhatsApp on seat arrival',
        conciergeDesc: 'Automates check-ins by priority and moves players to active seats when available.',
        seatSettlementTooltip: 'Automatically settles buy-ins and payouts in the ledger during seat changes.',
        twoTablesShort: '2T',
        oneTimeLabel: 'One-time',
        everyWeekLabel: 'Every Week',
        everyWeekSpecificDays: 'Every Week (Specific Days)',
        customSchedule: 'Custom Schedule',
        
        // Public Registration
        initializingSecureGate: 'Initializing Secure Gate',
        registrationFailure: 'Registration Failure',
        missingSessionId: 'Missing Session ID. Please use the full link you received on WhatsApp.',
        couldNotFindGame: 'We could not find the requested game. Make sure you used the correct link.',
        internalError: 'An internal error occurred. Please refresh the page.',
        tryAgain: 'Try Again',
        seeYouAtTheTable: 'See you at the table!',
        placeSavedSuccessfully: 'Your place has been saved successfully.',
        playerProfile: 'Player Profile',
        gameStakes: 'Game Stakes',
        welcomeBack: 'Welcome back, {{name}}!',
        welcomeToReshima: 'Welcome to Reshima',
        systemRecognizedYou: 'The system has recognized you. Choose a table and let\'s go.',
        whatIsYourName: 'What is your name at the table?',
        enterDetailsQuickRegistration: 'Enter details for quick registration.',
        fullNameNickname: 'Full Name / Nickname',
        savedOnDevice: 'Saved on your device · No need to fill again',
        continueToTable: 'Continue to Table Selection',
        saving: 'Saving...',
        mainTable: 'Main Table',
        table02: 'Table 02',
        secureHandshakeEstablished: 'Secure Handshake Established',
        alreadyExistsUse: ' already exists. Use {{name}}?',
        addPlayerFirst: 'Please add a player first',
        confirmExit: 'Confirm Exit (Cashout)',
        confirmExitMessage: 'Confirm exit for {{name}} of ₪{{amount}}? Player will be removed from the table.',
        paymentMethod: 'Payment Method',
        backToAmount: 'Back to edit amount',
        activePlayerDetails: 'Active Player Details',
        totalBuyins: 'Total Buy-ins',
        actions: 'Actions',
        buyinHistory: 'Buy-in History',
        confirmAll: 'Confirm All',
        min: 'Min',
    },

    he: {
        // App name
        appName: 'הרשימה',

        // Authentication
        login: 'התחברות',
        logout: 'התנתקות',
        email: 'אימייל',
        password: 'סיסמה',
        signIn: 'כניסה',

        // Navigation
        dashboard: 'דשבורד',
        sessions: 'סשנים',
        stadium: 'אצטדיון',
        players: 'שחקנים',
        history: 'היסטוריה',
        navActiveGame: 'מנהל רשימות',
        navCommunity: 'קהילה',
        navHistory: 'היסטוריית סשנים',
        sessionManagerSubtitle: 'כל הסשנים שלך במבט אחד',
        ledgerManagerSubtitle: 'רשימות ממוינות לפי תאריך',
        hospitality: 'ניהול אירוח',

        // Stadium / Tables
        table: 'שולחן',
        table1: 'שולחן 1',
        table2: 'שולחן 2',
        holdem: 'טקסס הולדם',
        omaha: 'אומהה',
        seat: 'מושב',
        emptySeat: 'מושב פנוי',
        dealer: 'דילר',

        // Players
        playerName: 'שם שחקן',
        totalSpent: 'סה"כ הוצאות',
        totalProfitLoss: 'רווח/הפסד',
        addPlayer: 'הוסף שחקן',
        selectPlayer: 'בחר שחקן',
        createNewPlayer: 'צור שחקן חדש',
        searchPlayers: 'חפש שחקנים...',

        // Ledger
        ledger: 'פנקס חשבונות',
        pool: 'קופה',
        house: 'הבית',
        buyIn: 'קנייה',
        cashOut: 'משיכה',
        totalIn: 'סה"כ נכנס',
        income: 'הכנסות',
        expenses: 'הוצאות',
        deposits: 'הפקדות',
        withdrawals: 'משיכות',
        addEntry: 'הוסף רשומה',
        amount: 'סכום',
        description: 'תיאור',
        timestamp: 'זמן',
        grandTotal: 'סה"כ כולל',
        netBalance: 'יתרה נטו',
        playerList: 'רשימת שחקנים',
        collected: 'נגבה',

        // Expense types
        food: 'אוכל',
        dealerFee: 'דמי דילר',
        tips: 'טיפים',
        fees: 'עמלות',

        // Roles
        rolePlayer: 'שחקן',
        roleFloor: 'פלור',
        roleDealer: 'דילר',
        slot: 'סלוט',
        total: 'סה"כ',
        floor: 'פלור',
        promote: 'קידום',
        demote: 'הורדה',
        generalPlayers: 'שחקנים כלליים',
        floors: 'רצפות',
        dealers: 'מחלקים',
        searchMembers: 'חיפוש חברים...',

        // Session lifecycle
        startSession: 'התחל סשן',
        endSession: 'סיים סשן',
        endSessionConfirm: 'האם אתה בטוח שברצונך לסיים את הסשן? הנתונים יישמרו בהיסטוריית הסשנים.',
        activeSession: 'סשן פעיל',
        sessionHistory: 'היסטוריית סשנים',

        // Session Schedule & Lifecycle
        newSession: 'סשן חדש',
        newGame: 'סשן חדש',
        sessionDate: 'תאריך',
        sessionTime: 'שעה',
        gameDate: 'תאריך',
        gameTime: 'שעה',
        stakes: 'עמדות',
        minBuyIn: 'קנייה מינימלית',
        makeRecurring: 'חזרתי (שבועי)',
        listManagement: 'ניהול רשימות',
        listManagementSubtitle: 'סשן פעיל וסשנים קרובים',
        currentLedger: 'סשן פעיל',
        futureLedgers: 'סשנים קרובים',
        noOngoingGame: 'אין סשן פעיל',
        noActiveSession: 'אין סשן פעיל',
        noUpcomingSessions: 'אין סשנים קרובים',
        goToDashboard: 'עבור ללוח הבקרה להתחלת סשן',
        scheduleNewGame: 'תזמן סשן חדש',
        ongoing: 'פעיל',
        upcoming: 'קרוב',
        startNow: 'התחל',
        openLedger: 'פתח רשימה',
        viewLedger: 'צפה ברשימה',
        ongoingGame: 'סשן פעיל',
        sessionDetails: 'פרטי סשן',
        saveChanges: 'שמור שינויים',
        upcomingSessions: 'סשנים קרובים',
        lastSessions: 'סשנים אחרונים',

        // Actions
        add: 'הוסף',
        edit: 'ערוך',
        delete: 'מחק',
        save: 'שמור',
        cancel: 'בטל',
        confirm: 'אשר',
        close: 'סגור',

        // Language
        language: 'שפה',
        english: 'English',
        hebrew: 'עברית',

        // Dashboard
        welcome: 'ברוכים הבאים',
        dashboardSubtitle: 'הסשנים שלך במבט אחד.',
        startNewGame: 'סשן חדש',
        lastCompletedGame: 'סשנים אחרונים',
        noCompletedGames: 'אין סשנים שהסתיימו עדיין.',
        viewLedgerHistory: 'כל הסשנים',
        goToHistory: 'כל הסשנים →',
        nextScheduledGame: 'סשן קרוב הבא',
        startsAt: 'מתחיל ב-',
        undo: 'בטל פעולה',
        redo: 'בצע שוב',
        noUpcomingGames: 'אין סשנים מתוכננים.',
        confirmDeletePlayer: 'האם אתה בטוח שברצונך למחוק שחקן זה?',
        fullNamePlaceholder: 'לדוגמה: דוד כהן',
        phonePlaceholder: 'לדוגמה: 054-1234567',
        maxLimitPlaceholder: 'השאיר ריק ללא הגבלה',
        savePlayer: 'שמור שחקן',

        // Community & Profiles
        communitySubtitle: 'נהל את בסיס השחקנים, התפקידים והפרופילים שלך.',
        playerProfiles: 'פרופילי שחקנים',
        noPlayersFound: 'לא נמצאו שחקנים התואמים לחיפוש שלך.',
        emptyPlayersHelp: 'לחץ על "הוסף שחקן חדש" כדי לבנות את מאגר הנתונים שלך.',
        addNewPlayer: 'הוסף שחקן חדש',
        searchNamePhone: 'חפש לפי שם או טלפון...',
        noPhone: 'אין טלפון',
        lifetimeNet: 'רווח/הפסד כולל',
        editPlayer: 'ערוך שחקן',
        fullName: 'שם מלא *',
        phoneNumber: 'מספר טלפון',
        maxBuyinLimit: 'תקרת קנייה (₪)',
        gamesPlayed: 'משחקים',
        ltv: 'ערך כולל',
        phone: 'טלפון',
        maxLimit: 'תקרה מקסימלית',

        // History
        ledgerHistory: 'היסטוריית הפנקס',
        historySubtitle: 'סקור מפגשים קודמים שהסתיימו וארכיונים.',
        noHistoryFound: 'לא נמצאו מפגשים שהסתיימו או ארכיונים.',
        historyEmptyHelp: 'משחקים יופיעו כאן לאחר סיום משחק פעיל.',
        historyCompleted: 'הושלם',
        viewLedgerDetails: 'צפה בפרטי הפנקס',
        netBalanceHistory: 'מאזן נטו',

        // Hospitality
        hospitalityTitle: 'ניהול הרשמות',
        hospitalityManagement: 'ניהול אירוח',
        hospitalitySub: 'מסעדות ותפריטים לסשנים שלך',
        addRestaurant: 'הוסף מסעדה',
        noRestaurants: 'אין מסעדות רשומות עדיין',
        noRestaurantsSub: 'הוסף מסעדה ידנית או יבא מ-Wolt',
        items: 'פריטים',
        confirmDeleteRestaurant: 'למחוק מסעדה זו?',
        editRestaurant: 'ערוך מסעדה',
        addNewRestaurant: 'הוסף מסעדה חדשה',
        importFromWolt: 'יבא תפריט מ-Wolt',
        optional: 'אופציונלי',
        importing: 'מייבא...',
        import: 'יבא',
        applyImport: 'טען תפריט — אפשר לערוך לפני שמירה',
        restaurantName: 'שם המסעדה',
        restaurantPlaceholder: "בורגר ראנץ', מקדונלד'ס...",
        menuCount: 'תפריט ({{count}} פריטים)',
        addManually: '+ הוסף ידנית',
        itemName: 'שם המנה',
        descriptionOptional: 'תיאור (אופציונלי)',
        modifiersOptions: 'תוספות / אפשרויות',
        addGroup: '+ הוסף קבוצה',
        groupNamePlaceholder: "שם הקבוצה (למשל: 'תוספות', 'גודל')",
        required: 'חובה',
        multiSelect: 'בחירה מרובה',
        option: 'אפשרות',
        addOption: '+ הוסף אפשרות',
        saveRestaurant: 'שמור מסעדה',
        scrapeError: 'שירות מ-Wolt אינו זמין כרגע',
        activeSessionFeed: 'עדכון סשן בזמן אמת',
        liveData: 'נתונים בשידור חי',
        totalPot: 'סה"כ קופה',
        totalRake: 'סה"כ רייק',
        activeSeats: 'מקומות מאוישים',
        searchNamePhone: 'חפש לפי שם או טלפון...',
        noActiveRegistrations: 'אין הרשמות פעילות',
        whale: 'לוויתן',
        regular: 'קבוע',
        new: 'חדש',
        time: 'זמן',
        seatAtTable: 'הושיב בשולחן',
        seated: 'יושב',
        seatPlayer: 'הושבת שחקן',
        seatPlayerInstructions: 'אנא הקלד את סכום ה-Buy In ההתחלתי.',
        confirmSeating: 'אישור הושבה',
        accessRestricted: 'הגישה מוגבלת',
        backToDashboard: 'חזרה לדשבורד',

        // Master Ledger
        globalExpenses: 'הוצאות כלליות',
        globalCollected: 'גביה כללית (רייק)',
        noExpensesLogged: 'לא נרשמו הוצאות',
        noRakeLogged: 'לא נרשמו גביות / רייק',
        endSessionSummary: 'סיכום סיום סשן',
        t1Buyins: 'קניות שולחן 1',
        t2Buyins: 'קניות שולחן 2',
        netPoolRemaining: 'יתרה נטו בקופה',
        totalPlayersTables: '{{count}} שחקנים ב-{{tables}}',
        archiveWarning: 'סיום הסשן יעביר את כל הנתונים לארכיון ויעדכן את מאזני השחקנים.',
        confirmEnd: 'אשר סיום',
        ending: 'מסתיים...',
        selectTableFor: 'בחר שולחן עבור {{name}}',
        availableSessions: 'סשנים זמינים',

        // Table Drawer & Empty States
        openTable: 'פתח שולחן',
        closeTable: 'סגור שולחן',
        tableFull: 'השולחן מלא',
        noExpenses: 'אין הוצאות',
        noCollections: 'אין גביות',
        addExpense: 'הוסף הוצאה',
        addCollected: 'הוסף גבייה',

        // New Batch/Action Bar
        itemsSelected: 'נבחרו {{count}} פריטים',
        playerExists: 'כבר קיים. האם להשתמש ב-{{name}}?',
        removePlayer: 'הסרת שחקן',
        confirmRemovePlayer: 'האם אתה בטוח שברצונך להסיר את {{name}} מהשולחן?',
        payoutErrorNoPlayer: 'נא להוסיף שחקן תחילה',
        confirmExpense: 'אישור הוצאה',
        confirmExpenseMsg: 'הוספת הוצאה בסך ₪{{amount}} ({{desc}})',
        confirmCollection: 'אישור גבייה',
        confirmCollectionMsg: 'הוספת גבייה בסך ₪{{amount}} ({{desc}})',
        deleteExpense: 'מחיקת הוצאה',
        confirmDeleteExpense: 'האם אתה בטוח שברצונך למחוק את ההוצאה בסך ₪{{amount}} ({{desc}})?',
        deleteCollection: 'מחיקת גבייה',
        confirmDeleteCollection: 'האם אתה בטוח שברצונך למחוק את הגבייה בסך ₪{{amount}} ({{desc}})?',
        confirmCashout: 'אישור יציאה (Cashout)',
        confirmCashoutMsg: 'האם לאשר יציאה עבור {{name}} בסך ₪{{amount}}? השחקן יוסר מהשולחן.',
        cashoutAllTitle: 'פרישת כל השחקנים',
        cashoutAllMsg: 'האם אתה בטוח שברצונך לבצע פרישה מרוכזת לכל השחקנים בשולחן?',
        deleteBuyin: 'מחיקת קנייה',
        confirmDeleteBuyin: 'האם אתה בטוח שברצונך למחוק את הקנייה של {{name}} בסך ₪{{amount}}?',
        minBuyStatus: 'מינ׳ ₪{{amount}}',
        paid: 'שולם',
        cash: 'מזומן',
        credit: 'בעיגול',
        buyins: 'קניות',
        chips: 'צ\'יפים',
        cashoutAll: 'פרוש הכל',
        bought: 'קנה: ₪{{amount}}',
        approveAll: 'אשר הכל',
        clearSelection: 'נקה בחירה',
        deleteItems: 'מחק פריטים',
        duplicateItems: 'שכפל פריטים',
        confirmDelete: 'מחיקת סשן',
        confirmBulkDelete: 'מחיקה קבוצתית',
        confirmDeleteMsg: 'האם אתה בטוח שברצונך למחוק את הסשן? פעולה זו בלתי הפיכה.',
        confirmBulkDeleteMsg: 'אתה עומד למחוק {{count}} סשנים. פעולה זו בלתי הפיכה.',
        guestWelcome: 'ברוכים הבאים לגרסת ההדגמה. נתוני האורחים נמחקים כל 24 שעות.',
        noSessionsYet: 'אין סשנים עדיין',
        clickNewSession: 'לחץ על "סשן חדש" כדי להתחיל',
        recent: 'אחרונים',
        viewFullHistory: 'צפה בהיסטוריה המלאה →',
        sessionManager: 'ניהול סשנים',
        sessionManagerSubtitle: 'כל הסשנים שלך במבט אחד',

        // New Session Modal
        step: 'שלב',
        configurationTitle: 'הגדרת סשן',
        stepDateTime: 'שלב 1: תאריך ושעה',
        stepCapacity: 'שלב 2: קיבולת',
        upTo11: 'עד 11 שחקנים',
        oneTable: 'שולחן 1',
        twoTables: '2 שולחנות',
        upTo22: 'עד 22 שחקנים',
        stepRecurrence: 'שלב {num}: מחזוריות חכמה',
        oneTime: 'חד פעמי',
        everyWeek: 'כל שבוע (תזמן 4 קדימה)',
        stepHospitality: 'שלב {num}: אירוח וסקירה',
        conciergeAutomation: 'אוטומציית קונסיירז׳',
        arrivalConfirmation: 'אישור הגעה',
        mealSelection: 'בחירת ארוחה',
        waitlistAutomation: 'אוטומציית רשימת המתנה',
        waitlistAutomationDesc: 'הזמנה אוטומטית מרשימת ההמתנה אם מושב מתפנה',
        seatSettlement: 'סגירת מושב',
        triggerWhatsApp: 'שלח וואטסאפ בהגעה לשולחן',
        selectRestaurants: 'בחר מסעדות',
        reviewSummary: 'סיכום וסקירה',
        timingLabel: 'זמן:',
        capacityLabel: 'קיבולת:',
        automationLabel: 'אוטומציה:',
        creating: 'מייצר...',
        creatingSession: 'מייצר סשן...',
        createSession: 'צור סשן',
        live: 'LIVE',
        pot: 'קופה',
        done: 'הסתיים',
        start: 'התחל',
        soon: 'בקרוב',
        variant: 'סוג משחק',
        stakes: 'בליינדים',
        customStakesPlaceholder: 'בליינדים מותאמים (לדוגמה 50/100)',
        minBuyinAmount: 'קנייה מינימלית (₪)',
        stepCapacityTitle: 'שלב 2: קיבולת',
        stepRecurrenceTitle: 'שלב {{num}}: מחזוריות חכמה',
        stepHospitalityTitle: 'שלב {{num}}: אירוח וסקירה',
        seatSettlementDesc: 'שלח וואטסאפ בהגעה לשולחן',
        conciergeDesc: 'מנהל הרשמות לפי עדיפות ומעביר שחקנים למושבים פעילים כשמתפנה מקום.',
        seatSettlementTooltip: 'מבצע סגירה אוטומטית של קניות ומשיכות בפנקס בזמן החלפת מושב.',
        twoTablesShort: '2ש',
        oneTimeLabel: 'חד פעמי',
        everyWeekLabel: 'כל שבוע (תזמן 4 קדימה)',
        everyWeekSpecificDays: 'כל שבוע (ימים ספציפיים)',
        customSchedule: 'לו"ז מותאם אישית',

        // Public Registration
        initializingSecureGate: 'מאתחל שער מאובטח',
        registrationFailure: 'תקלה בהרשמה',
        missingSessionId: 'מזהה סשן חסר. נא להשתמש בקישור המלא שקיבלת בוואטסאפ.',
        couldNotFindGame: 'לא הצלחנו למצוא את המשחק המבוקש. וודא שבחרת בקישור הנכון.',
        internalError: 'אירעה שגיאה פנימית. נסה לרענן את העמוד.',
        tryAgain: 'נסה שוב',
        seeYouAtTheTable: 'נתראה בשולחן!',
        placeSavedSuccessfully: 'המקום שלך נשמר בהצלחה.',
        playerProfile: 'פרופיל שחקן',
        gameStakes: 'עמדות המשחק',
        welcomeBack: 'ברוך הבא, {{name}}!',
        welcomeToReshima: 'ברוכים הבאים לרשימה',
        systemRecognizedYou: 'המערכת זיהתה אותך. בחר שולחן וצא לדרך.',
        whatIsYourName: 'מה השם שלך ליד השולחן?',
        enterDetailsQuickRegistration: 'הכנס פרטים לרישום מהיר.',
        fullNameNickname: 'שם מלא / כינוי',
        savedOnDevice: 'נשמר במכשיר שלך · לא תצטרך למלא שוב',
        continueToTable: 'המשך לבחירת שולחן',
        saving: 'שומר...',
        mainTable: 'שולחן ראשי',
        table02: 'שולחן 02',
        secureHandshakeEstablished: 'חיבור מאובטח נוצר',
        alreadyExistsUse: ' כבר קיים. האם להשתמש ב-{{name}}?',
        addPlayerFirst: 'נא להוסיף שחקן תחילה',
        confirmExit: 'אישור יציאה (Cashout)',
        confirmExitMessage: 'האם לאשר יציאה עבור {{name}} בסך ₪{{amount}}? השחקן יוסר מהשולחן.',
        paymentMethod: 'אמצעי תשלום',
        backToAmount: 'חזור לעריכת סכום',
        activePlayerDetails: 'פרטי שחקן פעיל',
        totalBuyins: 'סה"כ קניות',
        actions: 'פעולות',
        buyinHistory: 'היסטוריית קניות',
        confirmAll: 'אשר הכל',
        min: 'מינ׳',
    },
};
